module.exports = __webpack_public_path__ + "img/avatar6.47630b4a.png";